/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Story_Upload_FailInputs */

const en_msg_story_upload_fail = /** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story upload failed`)
};

const es_msg_story_upload_fail = /** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al subir la historia`)
};

const fr_msg_story_upload_fail = /** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du téléchargement de la story`)
};

const de_msg_story_upload_fail = /** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Hochladen der Story`)
};

const id_msg_story_upload_fail = /** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengunggah cerita`)
};

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const ja_msg_story_upload_fail = en_msg_story_upload_fail;

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const zh_msg_story_upload_fail = en_msg_story_upload_fail;

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const ar_msg_story_upload_fail = en_msg_story_upload_fail;

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const it_msg_story_upload_fail = en_msg_story_upload_fail;

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const ru_msg_story_upload_fail = en_msg_story_upload_fail;

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const pt_msg_story_upload_fail = en_msg_story_upload_fail;

/** @type {(inputs: Msg_Story_Upload_FailInputs) => LocalizedString} */
const ko_msg_story_upload_fail = en_msg_story_upload_fail;

/**
* | output |
* | --- |
* | "Story upload failed" |
*
* @param {Msg_Story_Upload_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_story_upload_fail = /** @type {((inputs?: Msg_Story_Upload_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Story_Upload_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_story_upload_fail(inputs)
	if (locale === "es") return es_msg_story_upload_fail(inputs)
	if (locale === "fr") return fr_msg_story_upload_fail(inputs)
	if (locale === "de") return de_msg_story_upload_fail(inputs)
	if (locale === "ja") return ja_msg_story_upload_fail(inputs)
	if (locale === "zh") return zh_msg_story_upload_fail(inputs)
	if (locale === "ar") return ar_msg_story_upload_fail(inputs)
	if (locale === "id") return id_msg_story_upload_fail(inputs)
	if (locale === "it") return it_msg_story_upload_fail(inputs)
	if (locale === "ru") return ru_msg_story_upload_fail(inputs)
	if (locale === "pt") return pt_msg_story_upload_fail(inputs)
	return ko_msg_story_upload_fail(inputs)
});